import React from "react";
import Modal from "../Modal/Modal";
import styles from "./ChartModal.module.scss";
interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  jobData: any;
  textLogData: any;
  sessionLogData: any;
}
function ChartModal(props: Props) {
  const { isOpen, setIsOpen, jobData, textLogData, sessionLogData } = props;
  console.log("sessionLog Data", sessionLogData);

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      style={
        sessionLogData?.rating === "thumbUp"
          ? { border: "3px solid #4caf50" }
          : sessionLogData?.rating === "thumbDown"
          ? { border: "3px solid #f44336" }
          : { border: "3px solid #b0b0b0" }
      }
    >
      <div className={styles.mainContainer}>
        <div className={styles.contentContainer}>
          <div className={styles.headingContainer}>
            <h1 className={styles.heading}>Text Log</h1>
          </div>
          {textLogData &&
            Object.keys(textLogData).map((key, i) => {
              if (key === "messageSent") {
                return (
                  <div className={styles.contentItem} key={i}>
                    <h2 className={styles.contentItemHeading}>{key}</h2>
                    <p className={styles.contentItemValue}>
                      {textLogData?.[key] ? "Yes" : "No"}
                    </p>
                  </div>
                );
              }
              if (key === "awsMessageResponse") {
                const prettyJson = JSON.stringify(textLogData?.[key], null, 2);
                return (
                  <div className={styles.contentItem} key={i}>
                    <h2 className={styles.contentItemHeading}>{key}</h2>
                    <pre className={styles.contentItemValue}>{prettyJson}</pre>
                  </div>
                );
              }
              return (
                <div className={styles.contentItem} key={i}>
                  <h2 className={styles.contentItemHeading}>{key}</h2>
                  <p className={styles.contentItemValue}>
                    {textLogData?.[key]}
                  </p>
                </div>
              );
            })}

          <div className={styles.headingContainer}>
            <h1 className={styles.heading}>Job</h1>
          </div>
          {jobData &&
            Object.keys(jobData).map((key, i) => {
              return (
                <div className={styles.contentItem} key={i}>
                  <h2 className={styles.contentItemHeading}>{key}</h2>
                  <p className={styles.contentItemValue}>{jobData?.[key]}</p>
                </div>
              );
            })}
          <div className={styles.headingContainer}>
            <h1 className={styles.heading}>Session Log</h1>
          </div>
          {sessionLogData &&
            Object.keys(sessionLogData).map((key, i) => {
              if (key !== "textLog" && key !== "job") {
                return (
                  <div className={styles.contentItem} key={i}>
                    <h2 className={styles.contentItemHeading}>{key}</h2>
                    <p className={styles.contentItemValue}>
                      {sessionLogData?.[key]}
                    </p>
                  </div>
                );
              }
              return <></>;
            })}
        </div>
      </div>
    </Modal>
  );
}

export default ChartModal;
